<div class="ipsos-page">
  <div class="ipsos-card">
    <header class="page-header">
      <h1 class="sam-page-heading">IPSOS FILIMPORT</h1>
    </header>

    <div class="ipsos-content">

  <div class="message error-message" *ngIf="errorMessage" role="alert">
    <mat-icon>error_outline</mat-icon>
    <span>{{ errorMessage }}</span>
    <button mat-icon-button type="button" aria-label="Stäng felmeddelandet" (click)="errorMessage = ''">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="message success-message" *ngIf="successMessage" role="status">
    <mat-icon>check_circle_outline</mat-icon>
    <span>{{ successMessage }}</span>
    <button mat-icon-button type="button" aria-label="Stäng bekräftelsen" (click)="successMessage = ''">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-tab-group class="ipsos-tabs">
    <mat-tab label="Importera">
      <div class="ipsos-tab-content import-tab-content">
    <mat-card class="panel upload-panel">
      <div class="panel-heading">
        <div>
          <h2>Ladda upp underlag</h2>
          <p>Semikolonseparerad CSV, högst 10 MB.</p>
        </div>
        <span class="step-badge">Steg 1</span>
      </div>

      <input #fileInput class="visually-hidden" type="file" accept=".csv,text/csv" (change)="chooseFile($event)">

      <div class="upload-zone" [class.has-file]="uploadFile">
        <div class="upload-symbol">
          <mat-icon>{{ uploadFile ? 'description' : 'cloud_upload' }}</mat-icon>
        </div>

        <ng-container *ngIf="!uploadFile; else selectedFile">
          <h3>Välj en CSV-fil</h3>
          <p>Filen valideras innan någon faktura kan skapas.</p>
          <button mat-stroked-button color="primary" type="button" (click)="fileInput.click()">
            <mat-icon>folder_open</mat-icon>
            Välj fil
          </button>
        </ng-container>

        <ng-template #selectedFile>
          <div class="file-details">
            <strong>{{ uploadFile?.name }}</strong>
            <span>{{ fileSize(uploadFile?.size || 0) }}</span>
          </div>
          <div class="file-actions">
            <button mat-button color="primary" type="button" (click)="fileInput.click()">Byt fil</button>
            <button mat-button type="button" (click)="clearFile(fileInput)">Ta bort</button>
          </div>
        </ng-template>
      </div>

      <button class="primary-action" mat-raised-button color="primary" type="button"
              [disabled]="!uploadFile || busy" (click)="upload()">
        <mat-icon>{{ busy ? 'hourglass_top' : 'fact_check' }}</mat-icon>
        {{ busy ? 'Laddar upp…' : 'Ladda upp och validera' }}
      </button>

      <div class="security-note">
        <mat-icon>verified_user</mat-icon>
        <span>Underlaget lagras privat och tas automatiskt bort enligt gällande lagringspolicy.</span>
      </div>
    </mat-card>
      </div>
    </mat-tab>

    <mat-tab label="Historik">
      <div class="ipsos-tab-content history-tab-content">
    <mat-card class="panel history-panel">
      <div class="panel-heading history-heading">
        <div>
          <h2>Tidigare importer</h2>
          <p>De 100 senaste underlagen.</p>
        </div>
        <button mat-icon-button type="button" aria-label="Uppdatera importer" [disabled]="historyLoading" (click)="refresh()">
          <mat-icon>refresh</mat-icon>
        </button>
      </div>

      <mat-progress-bar *ngIf="historyLoading" mode="indeterminate"></mat-progress-bar>

      <div class="history-empty" *ngIf="!historyLoading && imports.length === 0">
        <mat-icon>inbox</mat-icon>
        <strong>Inga importer ännu</strong>
        <span>Den första uppladdningen visas här.</span>
      </div>

      <div class="history-list" *ngIf="imports.length">
        <button class="history-item" type="button" *ngFor="let item of imports; trackBy: trackImport"
                [class.selected]="selected?.Id === item.Id" (click)="select(item)">
          <span class="history-file-icon"><mat-icon>description</mat-icon></span>
          <span class="history-copy">
            <strong>{{ item.OriginalFileName }}</strong>
            <span>{{ item.UploadedAt | swedishDate:'yyyy-MM-dd HH:mm' }}</span>
          </span>
          <span class="status-chip" [ngClass]="statusTone(item.Status)">
            <span class="status-pulse" *ngIf="isProcessing(item.Status)" aria-hidden="true"></span>
            <mat-icon *ngIf="item.Status === 6" aria-hidden="true">check_circle</mat-icon>
            <mat-icon *ngIf="item.Status === 2 || item.Status === 7" aria-hidden="true">error</mat-icon>
            {{ statusName(item.Status) }}
          </span>
          <mat-icon class="chevron">chevron_right</mat-icon>
        </button>
      </div>
    </mat-card>

  <mat-card class="panel detail-panel" *ngIf="selected">
    <div class="detail-header">
      <div class="detail-title">
        <span class="detail-icon"><mat-icon>description</mat-icon></span>
        <div>
          <span class="eyebrow">Valideringsärende</span>
          <h2>{{ selected.OriginalFileName }}</h2>
          <span class="detail-date">Uppladdad {{ selected.UploadedAt | swedishDate:'yyyy-MM-dd HH:mm' }}</span>
        </div>
      </div>
      <span class="status-chip detail-status" [ngClass]="statusTone(selected.Status)">{{ statusName(selected.Status) }}</span>
    </div>

    <section class="status-stage" [ngClass]="statusTone(selected.Status)" aria-live="polite">
      <div class="status-visual" aria-hidden="true">
        <div class="processing-orbit" *ngIf="isProcessing(selected.Status)">
          <span></span><span></span><span></span>
          <mat-icon>{{ selected.Status < 4 ? 'fact_check' : 'receipt_long' }}</mat-icon>
        </div>
        <div class="success-check" *ngIf="selected.Status === 6">
          <mat-icon>check</mat-icon>
        </div>
        <div class="ready-icon" *ngIf="selected.Status === 3">
          <mat-icon>verified</mat-icon>
        </div>
        <div class="error-icon" *ngIf="selected.Status === 2 || selected.Status === 7">
          <mat-icon>error_outline</mat-icon>
        </div>
      </div>

      <div class="status-content">
        <span class="status-kicker">{{ statusKicker(selected.Status) }}</span>
        <h3>{{ statusTitle(selected.Status) }}</h3>
        <p>{{ statusDescription(selected) }}</p>

        <div class="live-progress" *ngIf="isProcessing(selected.Status)">
          <div class="progress-copy">
            <span>{{ progressText || statusName(selected.Status) }}</span>
            <span *ngIf="totalRows">{{ processedRows }} av {{ totalRows }} rader</span>
          </div>
          <mat-progress-bar [mode]="totalRows && processedRows ? 'determinate' : 'indeterminate'"
                            [value]="totalRows ? processedRows * 100 / totalRows : 0"></mat-progress-bar>
        </div>

        <a class="invoice-link" mat-stroked-button color="primary"
           *ngIf="selected.Status === 6 && selected.InvoiceId"
           [routerLink]="['/combined-invoice-tool', selected.InvoiceId]">
          <mat-icon>open_in_new</mat-icon>
          Öppna samlingsfaktura #{{ selected.InvoiceId }}
        </a>
      </div>
    </section>

    <div class="process-steps" aria-label="Importens steg">
      <div class="process-step" [ngClass]="stepState(1, selected.Status)">
        <span class="step-marker"><mat-icon>{{ stepIcon(1, selected.Status) }}</mat-icon></span>
        <span><strong>Uppladdad</strong><small>Filen är mottagen</small></span>
      </div>
      <span class="step-line" [class.complete]="selected.Status >= 3"></span>
      <div class="process-step" [ngClass]="stepState(2, selected.Status)">
        <span class="step-marker"><mat-icon>{{ stepIcon(2, selected.Status) }}</mat-icon></span>
        <span><strong>Validerad</strong><small>Raderna kontrolleras</small></span>
      </div>
      <span class="step-line" [class.complete]="selected.Status === 6"></span>
      <div class="process-step" [ngClass]="stepState(3, selected.Status)">
        <span class="step-marker"><mat-icon>{{ stepIcon(3, selected.Status) }}</mat-icon></span>
        <span><strong>Faktura skapad</strong><small>Samlingsfakturan sparas</small></span>
      </div>
    </div>

    <div class="summary-grid">
      <div class="summary-item">
        <span>Rader</span>
        <strong>{{ selected.TotalRows || 0 }}</strong>
      </div>
      <div class="summary-item" [class.has-errors]="selected.ErrorCount > 0">
        <span>Valideringsfel</span>
        <strong>{{ selected.ErrorCount || 0 }}</strong>
      </div>
      <div class="summary-item amount">
        <span>Beräknad fakturatotal</span>
        <strong>{{ (selected.CalculatedTotal || 0) | number:'1.2-2' }} kr</strong>
        <small>inklusive moms och avgifter</small>
      </div>
      <div class="summary-item" *ngIf="selected.InvoiceId">
        <span>Skapad faktura</span>
        <strong>#{{ selected.InvoiceId }}</strong>
      </div>
    </div>

    <div class="inline-error" *ngIf="selected.ErrorMessage">
      <mat-icon>report_problem</mat-icon>
      <span>{{ selected.ErrorMessage }}</span>
    </div>

    <div class="detail-actions">
      <button mat-raised-button color="primary" type="button" [disabled]="selected.Status !== 3 || busy" (click)="approve()">
        <mat-icon>receipt_long</mat-icon>
        {{ busy ? 'Startar…' : 'Godkänn och skapa samlingsfaktura' }}
      </button>
      <button mat-stroked-button type="button" (click)="openSource()">
        <mat-icon>open_in_new</mat-icon>
        Öppna originalfil
      </button>
    </div>
  </mat-card>

  <mat-card class="panel results-panel" *ngIf="selected && (rowsLoading || rows.length)">
    <div class="panel-heading results-heading">
      <div>
        <h2>Valideringsresultat</h2>
        <p>Kontrollera raderna innan importen godkänns.</p>
      </div>
      <span class="result-count" *ngIf="rows.length">{{ rows.length }} rader</span>
    </div>

    <mat-progress-bar *ngIf="rowsLoading" mode="indeterminate"></mat-progress-bar>

    <div class="table-wrap" *ngIf="rows.length">
      <table mat-table [dataSource]="rows">
        <ng-container matColumnDef="RowNumber"><th mat-header-cell *matHeaderCellDef>Rad</th><td mat-cell *matCellDef="let row">{{ row.RowNumber }}</td></ng-container>
        <ng-container matColumnDef="ExternalEmploymentNumber"><th mat-header-cell *matHeaderCellDef>Anställningsnr</th><td mat-cell *matCellDef="let row">{{ row.ExternalEmploymentNumber || '–' }}</td></ng-container>
        <ng-container matColumnDef="MaskedPersonalNumber"><th mat-header-cell *matHeaderCellDef>Person</th><td mat-cell *matCellDef="let row">{{ row.MaskedPersonalNumber }}</td></ng-container>
        <ng-container matColumnDef="Date"><th mat-header-cell *matHeaderCellDef>Period</th><td mat-cell *matCellDef="let row">{{ row.StartDate | swedishDate:'yyyy-MM-dd' }} – {{ row.EndDate | swedishDate:'yyyy-MM-dd' }}</td></ng-container>
        <ng-container matColumnDef="WorkedHours"><th mat-header-cell *matHeaderCellDef>Timmar</th><td mat-cell *matCellDef="let row">{{ row.WorkedHours | number:'1.0-2' }}</td></ng-container>
        <ng-container matColumnDef="GrossHourlySalary"><th mat-header-cell *matHeaderCellDef>Timlön</th><td mat-cell *matCellDef="let row">{{ row.GrossHourlySalary | number:'1.2-2' }} kr</td></ng-container>
        <ng-container matColumnDef="CalculatedAmount"><th mat-header-cell *matHeaderCellDef>Belopp</th><td mat-cell *matCellDef="let row"><strong>{{ row.CalculatedAmount | number:'1.2-2' }} kr</strong></td></ng-container>
        <ng-container matColumnDef="Errors">
          <th mat-header-cell *matHeaderCellDef>Validering</th>
          <td mat-cell *matCellDef="let row">
            <span class="row-status valid" *ngIf="row.IsValid"><mat-icon>check_circle</mat-icon> Godkänd</span>
            <div class="row-errors" *ngIf="!row.IsValid">
              <span *ngFor="let error of row.FieldErrors"><mat-icon>error</mat-icon>{{ error }}</span>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns" [class.invalid-row]="!row.IsValid"></tr>
      </table>
    </div>
  </mat-card>
      </div>
    </mat-tab>
  </mat-tab-group>
    </div>
  </div>
</div>
